module.exports = __webpack_public_path__ + "static/media/intelligen.4f9da098.png";